import app from 'flarum/forum/app';
import FormModal from 'flarum/common/components/FormModal';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import { statuses, StatusLabel } from '../../common/sublace';

/** Окно выбора статуса темы для персонала. */
export default class StatusModal extends FormModal {
  oninit(vnode) {
    super.oninit(vnode);
    this.selected = this.attrs.discussion.sublaceStatus() || '';
  }
  className() {
    return 'SublaceStatusModal Modal--small';
  }
  title() {
    return 'Статус темы';
  }
  content() {
    const list = statuses();
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "SublaceStatusModal-hint"
    }, "\u0418\u0442\u043E\u0433\u043E\u0432\u044B\u0435 \u0441\u0442\u0430\u0442\u0443\u0441\u044B \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0442 \u0442\u0435\u043C\u0443 \u0434\u043B\u044F \u043E\u0442\u0432\u0435\u0442\u043E\u0432. \u0418\u0433\u0440\u043E\u043A\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0441\u043C\u0435\u043D\u0443 \u0441\u0442\u0430\u0442\u0443\u0441\u0430 \u0432 \u043B\u0435\u043D\u0442\u0435 \u0442\u0435\u043C\u044B."), m("div", {
      className: "SublaceStatusModal-list",
      role: "radiogroup"
    }, list.map(status => m("button", {
      type: "button",
      role: "radio",
      "aria-checked": this.selected === status.key ? 'true' : 'false',
      className: 'SublaceStatusModal-option' + (this.selected === status.key ? ' is-selected' : ''),
      style: {
        '--status-color': status.color
      },
      onclick: () => this.selected = status.key
    }, m(StatusLabel, {
      status: status
    }), status.closes ? m("span", {
      className: "SublaceStatusModal-closes"
    }, m(Icon, {
      name: "fas fa-lock"
    }), " \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u0435\u0442") : null)), m("button", {
      type: "button",
      role: "radio",
      "aria-checked": this.selected === '' ? 'true' : 'false',
      className: 'SublaceStatusModal-option SublaceStatusModal-option--none' + (this.selected === '' ? ' is-selected' : ''),
      onclick: () => this.selected = ''
    }, "\u0411\u0435\u0437 \u0441\u0442\u0430\u0442\u0443\u0441\u0430")), m("div", {
      className: "Form-group"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      type: "submit",
      loading: this.loading
    }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")));
  }
  onsubmit(e) {
    e.preventDefault();
    const discussion = this.attrs.discussion;
    if ((discussion.sublaceStatus() || '') === this.selected) {
      this.hide();
      return;
    }
    this.loading = true;
    discussion.save({
      sublaceStatus: this.selected
    }).then(() => {
      this.hide();
      if (app.current.matches(DiscussionPage)) {
        app.current.get('stream').update();
      }
      m.redraw();
    }).catch(() => {}).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('sublace-forum', 'forum/components/StatusModal', StatusModal);